import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import { hooks } from '../../../config/api';
export function useFindFeeScheduleInsurances(contactId, selectedPlan) {
  var _selectedPlan$fee_sch, _response$data$data, _response$data;
  var _hooks$useFind = hooks.useFind('insurance', {
      person: contactId,
      plan_type: 'social',
      state: 'active,pending',
      'plan.fee_schedules': (_selectedPlan$fee_sch = selectedPlan.fee_schedules) === null || _selectedPlan$fee_sch === void 0 || (_selectedPlan$fee_sch = _filterInstanceProperty(_selectedPlan$fee_sch).call(_selectedPlan$fee_sch, function (feeSchedule) {
        return feeSchedule.allow_multiple_enrollments;
      })) === null || _selectedPlan$fee_sch === void 0 ? void 0 : _mapInstanceProperty(_selectedPlan$fee_sch).call(_selectedPlan$fee_sch, function (feeSchedule) {
        return feeSchedule.id;
      }).join(',')
    }, {
      queryConfig: {
        enabled: selectedPlan.enrollment_required,
        placeholderData: undefined
      }
    }),
    response = _hooks$useFind.data,
    areInsurancesLoading = _hooks$useFind.areInsurancesLoading;
  var clientInsurances = (_response$data$data = response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.data) !== null && _response$data$data !== void 0 ? _response$data$data : [];
  var _hooks$usePopulate = hooks.usePopulate('plan', 'plan', clientInsurances, {
      queryConfig: {
        placeholderData: undefined
      }
    }),
    isPlanLoading = _hooks$usePopulate.isLoading;
  return {
    clientInsurances: clientInsurances,
    isLoading: areInsurancesLoading || isPlanLoading
  };
}
;
//# sourceMappingURL=useFindFeeScheduleInsurances.js.map